<wbo-search-page>
    <wbo-entity-actions>
        <wbo-entity-action (click)="export()" [title]="'wbo.opt-in-marketing.search.actions.export'"></wbo-entity-action>
    </wbo-entity-actions>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="firstName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="lastName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="email">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'mobilePhone'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'postCode'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'membershipType'">
                <wbo-membership-type-multi-select-search-control></wbo-membership-type-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-column [allowDescendingSorting]="false" field="firstName"></wbo-column>
        <wbo-column [allowDescendingSorting]="false" field="lastName"></wbo-column>
        <wbo-column [allowDescendingSorting]="false" field="email"></wbo-column>
        <wbo-column [sortable]="false" field="mobilePhone"></wbo-column>
        <wbo-column [allowDescendingSorting]="false" field="postCode"></wbo-column>
        <wbo-column [allowDescendingSorting]="false" field="membershipTypeName"></wbo-column>
        <wbo-date-time-column field="created"></wbo-date-time-column>
        <wbo-date-time-column field="lastUpdated"></wbo-date-time-column>
        <wbo-date-time-column field="optedIn"></wbo-date-time-column>
    </wbo-search-grid>
</wbo-search-page>
